'use client';

import { PopoverArrow } from '@radix-ui/react-popover';
import { Bookmarks } from '@/components/Bookmarks/BookmarkModal';
import { DrawerWrapper } from '@/components/Bookmarks/BookmarkModal/modules/Drawer';
import { Popover, PopoverContent, PopoverTrigger } from '@/components/ui/popover';
import type { Bookmark } from '@/types/bookmarks';
import type { User } from '@/types/user';
import AccountContent from './Content';
import AccountTrigger from './Trigger';

/* 2026-01-21 Issue with hydration missmatch on Radix asChild
https://github.com/radix-ui/primitives/issues/3700
 Will be fixed here:
https://github.com/facebook/react/pull/35518
 */
const AccountPopover = ({ bookmarks, user }: { bookmarks: Bookmark[]; user: User }) => {
  return (
    <>
      <Bookmarks
        bookmarks={bookmarks}
        user={user}
      />
      <div className='tablet-lg:hidden'>
        <Popover>
          <PopoverTrigger asChild>
            <AccountTrigger />
          </PopoverTrigger>
          <PopoverContent
            side='bottom'
            align='end'
            sideOffset={6}
            className='z-101 p-1'
            id='account-popover'
          >
            <PopoverArrow className='-translate-y-px fill-white' />
            <AccountContent closeOnClick />
          </PopoverContent>
        </Popover>
      </div>
      <div className='tablet-lg:block hidden'>
        <DrawerWrapper
          trigger={<AccountTrigger />}
          title='Konto'
        >
          <AccountContent />
        </DrawerWrapper>
      </div>
    </>
  );
};
export default AccountPopover;
